﻿$.fn.dxCtrlPlanitiDashBoard = function custom_dxCtrlPlanitiDashBoard(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-ctrlplanitidashboard dx-ctrl");
        this.createInstance(new cdxCtrlPlanitiDashBoard(this, option));
    }
    return this;
}

window.cdxCtrlPlanitiDashBoard = function (container, option) {
    var Me = this;


    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
            dx.option(name, value);
        }
    }

    function mConstruit() {
        container.empty();
    }

    this.element = function () { return container; }

    mConstruit();
}